import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Calendar, User } from "lucide-react";
import { useI18n } from "@/i18n";
import api from "@/lib/api";

export default function NewsDetail() {
  const { t, lang } = useI18n();
  const { id } = useParams();
  const [n, setN] = useState(null);
  useEffect(() => { api.get(`/news/${id}?lang=${lang}`).then((r) => setN(r.data)).catch(() => {}); }, [id, lang]);
  if (!n) return <div className="max-w-4xl mx-auto px-4 py-20 text-slate-500">{t("loading")}</div>;
  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <Link to="/noticias" className="inline-flex items-center gap-1 text-th-blue hover:text-th-gold text-sm mb-6" data-testid="back-news"><ArrowLeft className="w-4 h-4" />{t("nav_news")}</Link>
      <h1 className="font-display font-bold text-3xl sm:text-4xl text-th-blue leading-tight">{n.title}</h1>
      <div className="mt-3 flex flex-wrap gap-4 text-sm text-slate-500">
        <span className="flex items-center gap-1"><Calendar className="w-4 h-4 text-th-gold" />{n.published_at ? new Date(n.published_at).toLocaleDateString(lang) : ""}</span>
        {n.author_name && <span className="flex items-center gap-1"><User className="w-4 h-4 text-th-gold" />{n.author_name}</span>}
      </div>
      {n.image_url && <img src={n.image_url} alt={n.title} className="mt-6 w-full rounded-2xl object-cover max-h-96" />}
      <div className="mt-6 text-slate-700 leading-relaxed whitespace-pre-line text-lg">{n.body}</div>
    </article>
  );
}
